import React from 'react'
import Sidebar from '../Sidebar'
import AllUsers from './AllUsers'

const Users = () => {
    return (
        <div className='users'>
            <Sidebar />
            <AllUsers />
        </div>
    )
}

export default Users